import type { AvatarSize } from '../../__generated__/chirp/com/hubspot/avatars/rpc/AvatarsRpc';
import { RETINA_MULTIPLIER } from '../Constants';

const AVATAR_SIZE_BREAKPOINTS: { maxRetina: number; size: AvatarSize }[] = [
  { maxRetina: 48, size: 'SIZE_48' },
  { maxRetina: 64, size: 'SIZE_64' },
  { maxRetina: 72, size: 'SIZE_72' },
  { maxRetina: 75, size: 'SIZE_75' },
  { maxRetina: 96, size: 'SIZE_96' },
  { maxRetina: 140, size: 'SIZE_140' },
  { maxRetina: 144, size: 'SIZE_144' },
  { maxRetina: 200, size: 'SIZE_200' },
  { maxRetina: 216, size: 'SIZE_216' },
];

export function dimensionToAvatarSize(
  dimension: number | undefined
): AvatarSize | undefined {
  if (dimension === undefined) return undefined;
  const retinaSize = dimension * RETINA_MULTIPLIER;
  return (
    AVATAR_SIZE_BREAKPOINTS.find((b) => retinaSize <= b.maxRetina)?.size ??
    'SIZE_216'
  );
}
